import React from "react";
import styled from "styled-components";
import { ITabInformation, TabButtons } from "../../../App/Tabs";
import { AnalyticsViews } from "../../../App/Analytics/Common/index";

const TabsContainer = styled.div`
  position: relative;
  margin-top: 1.6rem;
`;

export interface IAnalyticsTabsProps {
  changeAnalyticsView: (view: AnalyticsViews) => () => void;
  view: AnalyticsViews;
}

export const AnalyticsTabs: React.FC<IAnalyticsTabsProps> = ({ changeAnalyticsView, view }) => {
  const tabs: Array<ITabInformation<AnalyticsViews>> = [
    {
      queryParam: "graphs",
      tabItem: AnalyticsViews.Graphs,
      title: "Charts",
    },
    {
      queryParam: "users",
      tabItem: AnalyticsViews.Users,
      title: "Table",
    },
  ];

  return (
    <TabsContainer>
      <TabButtons tabs={tabs} displayed={view} setSelected={changeAnalyticsView} queryParamName="view" />
    </TabsContainer>
  );
};
